import RouteTemplate from 'ember-route-template'
import { SiteHeader } from 'district-ui-client/components/site-header'

export default RouteTemplate(
  <template>
    <SiteHeader />
    <div class="flex-shrink flex-grow overflow-y-auto px-8 py-10">
      {{outlet}}
    </div>
  </template>,
)
